export default {
  path: '/bug_types',
  name: 'bug_types',
  component: () => import('../components/bugtype/Layout'),
  redirect: { name: 'BugtypeList' },
  meta: {
    breadcrumb: 'ticket.bugtypes',
  },
  children: [
    {
      name: 'BugtypeList',
      path: '',
      component: () => import('../views/bugtype/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'BugtypeCreate',
      path: 'new',
      component: () => import('../views/bugtype/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'BugtypeUpdate',
      path: ':id/edit',
      component: () => import('../views/bugtype/Update'),
      meta: {
        breadcrumb: 'ticket.bugtype',
      },
    },
    {
      name: 'BugtypeShow',
      path: ':id',
      component: () => import('../views/bugtype/Show'),
      meta: {
        breadcrumb: 'ticket.bugtype',
      },
    }
  ]
};
